import React from 'react'
import { Geometry, Base, Subtraction } from '@react-three/csg'

export const Ring = ({ color, size, position, rotation, width = 0.5 }) => {
	return (
		<mesh position={position} rotation={rotation}>
			<meshStandardMaterial color={color} />
			<Geometry>
				<Base>
					<cylinderGeometry args={size} />
				</Base>
				<Subtraction position={[0, 0, 0]}>
					<cylinderGeometry
						args={size.map((num, index) => {
							if (index < 2) {
								return num - width
							}
							return num
						})}
					/>
				</Subtraction>
			</Geometry>
		</mesh>
	)
}
